import {
    useGetDebriefTourSettingQuery,
    useSaveDebriefTourSettingMutation,
} from 'ff/debrief/features/TracklogApi';

export function useSyncSettings() {
    const { data: savedSettings } = useGetDebriefTourSettingQuery();
    const [saveTourSetting] = useSaveDebriefTourSettingMutation();

    return {
        savedSettings: savedSettings,
        saveTourSetting,
    };
}
